import BaseService from '@/features/BaseService';

export default class ClientService extends BaseService {

  constructor() {
    super('clients');
  }

  static toggleStatus({ id }) {
    return BaseService.request(
      'POST',
      'clients/toggle-status',
      { id },
    );
  }

}



// WEBPACK FOOTER //
// ./src/features/client/ClientService.js